import React from "react";
import { Tilt } from "react-tilt";
import { FiInfo } from "react-icons/fi";

interface BookingAnalyticsCardProps {
  metric: string;
  value: number;
  isSelected: boolean;
  report?: boolean;
  onClick: () => void;
}

const BookingAnalyticsCard: React.FC<BookingAnalyticsCardProps> = ({
  metric,
  value,
  isSelected,
  report = false,
  onClick,
}) => {
  return (
    <Tilt options={{ max: 25, scale: 1.05, speed: 400, perspective: 1000 }}>
      <div
        className={`${
          report ? "p-2 h-24 w-full text-xs" : "p-3"
        } rounded-lg cursor-pointer transition-all duration-300 booking-analytics-card ${
          isSelected
            ? "bg-gradient-to-br from-blue-500 to-blue-700 text-white shadow-lg"
            : "border border-gray-300 text-gray-600"
        } ${report ? "print:break-inside-avoid" : ""}`}
        onClick={onClick}
      >
        <label
          className={`flex items-center ${report ? "text-xs" : "text-sm"}`}
        >
          <input
            type="checkbox"
            className={`form-checkbox ${report ? "mr-1 w-3 h-3" : "mr-2"}`}
            value={metric}
            checked={isSelected}
            readOnly
          />
          <span className={report ? "leading-tight" : ""}>
            {metric === "Walk-in Bookings"
              ? "Walk-in"
              : metric === "Follow-up Bookings"
              ? "Follow-up"
              : metric}
          </span>
        </label>
        <p
          className={`${
            report ? "text-sm font-bold mt-1" : "text-2xl font-semibold mt-2"
          } ${isSelected ? "text-white" : "text-gray-800"}`}
        >
          {value}
        </p>
        {!report && (
          <span
            className={`text-xs flex items-center ${
              isSelected ? "text-blue-200" : "text-gray-400"
            }`}
          >
            <FiInfo className="w-3 h-3 mr-1" />
          </span>
        )}
      </div>
    </Tilt>
  );
};

export default BookingAnalyticsCard;
